<script>
    //正式服
    const http_url='https://www.vogemotor.com';
    const app_url='https://www.vogemotor.com/h5';
    //测试服
    // const http_url='http://longxin.test.esports168.com/';
    // const app_url='http://longxin.test.esports168.com/h5';

    const key = '191e14c02ae13a14d252e751211fc6a0';
    export default
    {
        http_url,//访问地址
        app_url,
        key,
    }
</script>



// WEBPACK FOOTER //
// src/config.vue